import Router from "next/router";
import Head from "next/head";
import Script from "next/script";
import Cohere from "cohere-js";
import { Toaster } from "react-hot-toast";

import { ThemeProvider } from "@mui/system";

import "../styles/global.css";
import theme from "../styles/theme";
import { AuthProvider } from "../auth/auth";
import OverlayAdBlocker from "../components/OverlayAdBlocker";

Router.events.on("routeChangeComplete", (url) => {
  window.analytics.page();
});

if (process.env.NODE_ENV === "production") {
  Cohere.init("jFJnvhFUCIFk28VvMMCZafvX");
}

function MyApp({ Component, pageProps }) {
  const getLayout = Component.getLayout || ((page) => page);

  return (
    <>
      <Head>
        <title>Channel</title>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </Head>
      <Script
        id="cloudinary"
        strategy="lazyOnload"
        src={"https://upload-widget.cloudinary.com/global/all.js"}
      />
      <Script
        id="segment"
        dangerouslySetInnerHTML={{
          __html: `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="GEdTPvLIoUBjRHYC3F2DbHs8LH8xu1lD";;analytics.SNIPPET_VERSION="4.15.3";
          analytics.load("${process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}");
          analytics.page();
          }}();`,
        }}
      />
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <Toaster />
          <OverlayAdBlocker />
          {getLayout(<Component {...pageProps} />)}
        </ThemeProvider>
      </AuthProvider>
    </>
  );
}
export default MyApp;
